import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { Spacer } from "../../components/spacer/spacer";
import { Text, Button } from "../../components";
import { Stack } from "../../components/layout/stack";
import { useNavigation } from "@react-navigation/native";
import { useTheme, Divider, ActivityIndicator, Headline } from "react-native-paper";
import { AddPaymentMethodCard } from "../../components/add-payment-method-card/add-payment-method-card";
import { ThemeType } from "../../theme/theme";
import { PaymentSourceType } from "../../enums";
import {
  MONEYGRAM_STATIC_INFO,
  PaymentMethodCardGroup,
} from "../payment-method/payment-method-card-group";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";

interface SelectAPaymentMethodProps extends Record<string, any> {
  propertyUnit: string;
  reservationId?: string | number;
  fromAutopay: boolean;
  allowedPayments?: any;
  shouldDisableCC?: any;
  allowCC: boolean;
  allowACH: boolean;
  currentPropertyFeeProfile: any;
  currentPropertyProfile: any;
  selected: any;
  emitSelected: any;
}

export const SelectAPaymentMethod = (selectAPaymentMethodProps: SelectAPaymentMethodProps) => {
  let {
    fromAutopay,
    paymentSources,
    currentPropertyFeeProfile: propFees = {},
    currentPropertyProfile,
  } = selectAPaymentMethodProps;

  let { certified_start_day, certified_end_day } = currentPropertyProfile || {};
  let paymentMethods;
  if (Array.isArray(paymentSources)) {
    paymentMethods = paymentSources.slice();
    if (!fromAutopay) {
      paymentMethods = [
        ...paymentMethods,
        { type: MONEYGRAM_STATIC_INFO, id: MONEYGRAM_STATIC_INFO },
      ];
    }
  }
  return (
    <SelectAPaymentMethodInner {...selectAPaymentMethodProps} paymentMethods={paymentMethods} />
  );
};

export const SelectAPaymentMethodInner = (selectAPaymentMethodProps: SelectAPaymentMethodProps) => {
  let {
    fromAutopay,
    allowedPayments,
    currentPropertyFeeProfile: propFees = {},
    currentPropertyProfile,
    shouldDisableCC = false,
    allowCC,
    allowACH,
    disabled,
    selected,
    paymentMethods,
    emitSelected,
  } = selectAPaymentMethodProps;

  let { certified_start_day, certified_end_day } = currentPropertyProfile || {};
  const theme = useTheme() as ThemeType;
  const styles = getStyles(theme);

  return (
    <Stack style={styles.container}>
      <Stack>
        {propFees && paymentMethods ? (
          <>
            <Spacer size="small"></Spacer>
            <PaymentMethodCardGroup
              paymentType={PaymentSourceType.CREDIT_CARD}
              paymentMethods={paymentMethods}
              selectAPaymentMethodProps={selectAPaymentMethodProps}
              shouldDisableCC={shouldDisableCC}
              allowCC={allowCC}
              allowedPayments={allowedPayments}
              certifiedDateRange={{ certified_start_day, certified_end_day }}
              selected={selected}
              emitSelected={emitSelected}
              fees={propFees}
            />
            <Spacer size="large"></Spacer>
            <PaymentMethodCardGroup
              paymentType={PaymentSourceType.BANK_ACCOUNT}
              paymentMethods={paymentMethods}
              selectAPaymentMethodProps={selectAPaymentMethodProps}
              allowACH={allowACH}
              allowedPayments={allowedPayments}
              certifiedDateRange={{ certified_start_day, certified_end_day }}
              selected={selected}
              emitSelected={emitSelected}
              fees={propFees}
            />
          </>
        ) : (
          <ActivityIndicator />
        )}
      </Stack>
    </Stack>
  );
};

const getStyles = (theme: ThemeType) => {
  const text = { color: theme.colors.surface };
  const { colors, spacing } = theme;
  return StyleSheet.create({
    container: {
      height: "auto",
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 15,
    },
    spaceBetween: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between",
    },
    spaceBetweenRow: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
  });
};
